module.exports = __webpack_public_path__ + "static/media/auto-mobile.e94e8d46.svg";